export default __webpack_public_path__ + "static/media/file-text.71418eea.svg";